module.exports = __webpack_public_path__ + "static/media/wp.4bbd0b4d.png";